import {createAction, createReducer} from '@reduxjs/toolkit';

import {completeOrderReview} from '../../../actions/completeOrder/completeOrder';
import {savePayment} from '../savePaymentData/savePaymentData';

export type PaymentMethodSaveType = {
    loading: boolean;
};
export const initialState: PaymentMethodSaveType = {
    loading: false,
};

export const savePaymentMethod = createAction<{token: string; method: string; id?: string}>(
    'CHECKOUT@PAYMENT_METHOD@SAVE',
);
export const changeLoadingSavePayment = createAction<boolean>(
    'CHECKOUT@PAYMENT_METHOD@CHANGE_LOADING',
);

export const paymentMethodSave = createReducer(initialState, builder =>
    builder
        .addCase(changeLoadingSavePayment, (state, action) => ({
            ...state,
            loading: action.payload,
        }))
        .addCase(savePayment.rejected, state => ({
            ...state,
            loading: false,
        }))
        .addCase(completeOrderReview.rejected, state => ({
            ...state,
            loading: false,
        }))
        .addCase(completeOrderReview.fulfilled, state => ({
            ...state,
            loading: false,
        })),
);
